import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://static.readdy.ai/image/5395687eba2a734bcb2dd68c996c233a/5a5afc594e796b563571738e53b59599.jpeg" 
              alt="ACE Consultancy Africa Logo" 
              className="h-12 w-12 object-contain"
            />
            <div>
              <div className={`text-xl font-bold transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
                ACE Consultancy
              </div>
              <div className={`text-xs transition-colors ${isScrolled ? 'text-gray-600' : 'text-white/80'}`}>
                Africa
              </div>
            </div>
          </div>

          <div className="hidden lg:flex items-center gap-8">
            <button onClick={() => scrollToSection('about')} className={`text-sm font-medium transition-colors hover:text-[#D4AF37] whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              About Us
            </button>
            <button onClick={() => scrollToSection('services')} className={`text-sm font-medium transition-colors hover:text-[#D4AF37] whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Services
            </button>
            <button onClick={() => scrollToSection('testimonials')} className={`text-sm font-medium transition-colors hover:text-[#D4AF37] whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Testimonials
            </button>
            <button onClick={() => scrollToSection('mission')} className={`text-sm font-medium transition-colors hover:text-[#D4AF37] whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Our Mission
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-[#D4AF37] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#C19B2E] transition-all whitespace-nowrap">
              Contact Us
            </button>
          </div>

          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center"
          >
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white shadow-lg">
          <div className="px-6 py-4 space-y-3">
            <button onClick={() => scrollToSection('about')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#D4AF37] py-2">
              About Us
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#D4AF37] py-2">
              Services
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#D4AF37] py-2">
              Testimonials
            </button>
            <button onClick={() => scrollToSection('mission')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#D4AF37] py-2">
              Our Mission
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-[#D4AF37] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#C19B2E] transition-all w-full whitespace-nowrap">
              Contact Us
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
